<template lang="pug">
  .documento
    .icone
      i.fa.fa-file.fa-2x
    .texto
      p.titulo: strong: a(:href="arquivo.url") {{ arquivo.nome }}
      p.desc: span {{ arquivo.desc }}
</template>

<style lang="scss">
  .documento {
    display: flex;
    margin: 25px 0;

    > .icone {
      margin-right: 15px;
      padding: 5px 0;
      color: $color-blue-dark;
    }

    > .texto {
      > .titulo { font-size: 17px; }
      > p:first-child { margin-bottom: 0; }
    }
  }
</style>

<script>
  export default {

    props: {
      arquivo: { type: Object, required: false }
    }

  }
</script>



// WEBPACK FOOTER //
// BaseLinkDocumento.vue?eed1afde